module.exports = __webpack_public_path__ + "static/media/loyalty.377aff1e.svg";